import React from 'react';
import DogPhotoGallery from './components/DogPhotoGallery';


function App() {
  return (
    <div style={{ backgroundColor: 'purple', minHeight: '100vh' }}>
      <DogPhotoGallery/>
    </div>
  );
}

export default App;
